import { Centred, Contents } from '../../styles/mixins'
import { RichText } from '../../styles/mixins'

const styles = theme => ({
  centred: {
    ...Centred(theme)
  },
  contents: {
    ...Contents(theme)
  },
  sectionImage: {
    width: '100%',
    maxWidth: 1024,
    marginBottom: theme.spacing.unit * 4
  },
  teaser: {
    height: '100%',
    minHeight: '60vh',
    // backgroundImage: 'linear-gradient(to right top, #051937, #004d7a, #008793, #00bf72, #a8eb12)',
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center'
  },
  text: {
    ...RichText(theme),
  },
})

export default styles



// WEBPACK FOOTER //
// ./src/components/story/styles.js